import React, {
  Fragment,
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import MuiButton from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CustomDialog from "../common/CustomDialog";
import { Button } from "primereact/button";
import AuthContext from "../../context/auth/AuthContext";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Tooltip } from "@mui/material";
import { DateTime } from "luxon";
import {
  ClientFilingTracker,
} from "../../types/ClientFilingMaster";
import Alert from "@mui/material/Alert";
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import type { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import useDialog from "../common/UseDialog";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import {
  FilingMasterWorkflowComment,
} from "../../types/FilingMaster";
import axios from "axios";
import Loader from '../common/Loader';
import usePermission from "../../usePermission";
import { TrackNowButton } from "../ui/TrackNowButton";
import { TrackNowSelect } from "../ui";


type Anchor = "top" | "left" | "bottom" | "right";
const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

interface CommonStaff {
  loginId: string; // Represents the login identifier, likely an email address
  userId: number;  // A unique identifier for the user
  userName: string; // The user's full name
}

export default function ClientFilingBulkStatusUpdate(props: {
  dockAt?: "top" | "left" | "bottom" | "right";
  show?: boolean;
  handleClose: () => void;
  statusRecords?: ClientFilingTracker[];
  refreshList: () => void;
  setClearSelectedRecords: (value: boolean) => void;
  handleRefreshTable: () => void;
  childList?: ClientFilingTracker[];
  commonStaffs?: [];
  value: any;
  selectedClientId: any;
  isDetailedView: boolean
  selectedCustomer: any
}) {
  const detailRowSx = {
    display: "grid",
    gridTemplateColumns: "140px minmax(0, 1fr)",
    columnGap: 2,
    alignItems: "start",
    width: "100%",
    py: 0.5,
  };

  const detailLabelSx = {
    fontSize: "0.9rem",
    fontWeight: 400,
    lineHeight: 1.4,
  };

  const detailValueSx = {
    fontSize: "0.9rem",
    fontWeight: 400,
    lineHeight: 1.4,
    minWidth: 0,
    overflowWrap: "anywhere",
    wordBreak: "break-word",
  };


  let { clientId } = useParams();
  const filingMasterContext = useContext(FilingMasterContext);
  const {
    getFilingMasterWorkflowComments,
    addFilingMasterWorkflowComment,
    getFilingMasterWorkflowCommentsAttachments,
  } = filingMasterContext;
  const formRef = useRef<HTMLFormElement>(null);
  const [data, setData] = React.useState<FilingMasterWorkflowComment[]>([]);
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const authContext = useContext(AuthContext);
  const { authUser, userRoles } = authContext;
  const [alertMessage, setAlertMessage] = useState("");
  const [approvalComment, setApprovalComment] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [selectedRecords, setSelectedRecords] = useState<ClientFilingTracker[]>([]);
  const [childList, setChildList] = useState<ClientFilingTracker[]>([])
  const [commonStaffs, setCommonStaffs] = useState<CommonStaff[]>([])
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [remainingChars, setRemainingChars] = useState(256);
  const [openAttachment, setOpenAttachment] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [staffAssignedList, setStaffAssignedList] = useState<any[]>([]);
  const [staffAssignedVal, setStaffAssignedVal] = useState<any[]>([]);
  const [statusOptValue, setStatusOptValue] = useState("")
  const [filingName, setFilingName] = useState<(string | undefined)[] | []>(
    []
  );
  const statusDropdown = [
    { name: 'Pending', code: 'Pending' },
    { name: 'In progress', code: 'In progress' },
    { name: 'Approved', code: 'Approved' },
    { name: 'Completed', code: 'Completed' },
  ];
  const navigate = useNavigate();
  // const [isPopUpVisible, setIsPopUpVisible] = useState(false);

  // function handleCloseClick() {

  //       setIsPopUpVisible(false);

  //     }

  useEffect(() => {
    if (props.show) {
      let statusRecordsArray = Array.isArray(props.statusRecords) ? props.statusRecords : [];
      let childListArray = Array.isArray(props.childList) ? props.childList : [];
      let commonStaffsArray: CommonStaff[] = Array.isArray(props.commonStaffs) ? props.commonStaffs : [];
      //  console.log("Props useeffect props.childList", props.childList, "statusRecords", props.statusRecords, "props.commonStaffs", props.commonStaffs);
      // console.log("Variable useeffect childListArray", childListArray, "statusRecordsArray", statusRecordsArray, "commonStaffsArray", commonStaffsArray);
      // Update status in statusRecordsArray based on matching fileTrackingId
      // const updatedStatusRecordsArray = statusRecordsArray.map((record) => {
      //   const matchingChild = childListArray.find((child) => child.fileTrackingId === record.fileTrackingId);
      //   return {
      //     ...record,
      //     status: matchingChild?.status || record.status, // Assign status from childListArray or retain the existing one
      //   };
      // });
      const updatedStatusRecordsArray = statusRecordsArray.map(record => ({
        ...record,
        remainingStaffs: record.staffAssigned
          ? record.staffAssigned.filter(
            staff => !commonStaffsArray.some(common => common.userId === staff.userId)
          )
          : [], // If staffAssigned is undefined, default to an empty array
      }));
      setSelectedRecords(() => updatedStatusRecordsArray)
      setChildList(() => childListArray)
      setCommonStaffs(() => commonStaffsArray)
      fetchStaffAssigned()
    };
  }, [props.statusRecords, props.show])

  useEffect(() => {
    if (props.show) {
      fetchStaffAssigned();
    }
  }, [props.show, props.statusRecords, userRoles, clientId])

  const fetchStaffAssigned = async () => {

    let recordTypes = Array.isArray(props.statusRecords) ? props.statusRecords.map((ele) => ele.recordType ? ele.recordType : "TrackNow") : [];


    if (userRoles !== undefined && userRoles?.length > 0) {
      const payload = props && props?.statusRecords?.map((item) => {
        return {
          filingId: item.filingId,
          previousStartDate: item.previousStartDate,
          customerId: Number(clientId),
          ...(props.isDetailedView
            ? {
              isDetailedView: true,
              fileTrackingId: item.fileTrackingId,
            }
            : {}),
        };
      });

      const res = await axios.post(
        `${API_BASE_URL}/Customer/CommonStaffsForBulkUpdateByFilingIds`,
        payload
      );

      const staffList = res.data.data.multipleFilingCommonStaff
        .map((ele: any) => ({
          name: ele.userName
            ? ele.userName.charAt(0).toUpperCase() + ele.userName.slice(1)
            : "",
          code: ele.userId,
          loginId: ele.loginId,
        }))
        .filter((ele: any) => ele.name) // remove empty names
        .filter(
          (value: any, index: any, self: any) =>
            index === self.findIndex((t: any) => t.name === value.name)
        );

      staffList.sort(function (a: any, b: any) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      })

      const staffs = staffList.map(
        ({ name, code }: { name: string; code: number | string }) => ({
          name,
          code,
        })
      );
      setStaffAssignedList(() => staffs);
    } else {
      setStaffAssignedList(() => []);
    }
  }

  useEffect(() => {
    const exsistingUserId = commonStaffs.map((ele: any) => ele.userId)
    setStaffAssignedVal(exsistingUserId)
  }, [commonStaffs])

  useEffect(() => {
    setShowError(false)
  }, [staffAssignedVal, statusOptValue])

  const displayStaffVal = (selected: any) => {
    const staffNames = selected.map((ele: any) => {
      const staff = staffAssignedList.find((item) => item.code === ele);
      return staff ? staff.name : ""; // Fallback to empty string if not found
    });

    return staffNames.filter(Boolean).join(", "); // Remove empty strings
  };


  const closeAlert = () => {
    setShowAlert(false);
    // props.handleClose();
    // navigate("/filing-master-approval-list");
  };

  const onFileChange = async (event: any) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const footerContent = (
    <div>
      <Button
        label="OK"
        icon="pi pi-check"
        onClick={() => closeAlert()}
        autoFocus
      />
    </div>
  );
  const handleStatausChange = (event: SelectChangeEvent<unknown>) => {
    setStatusOptValue(event.target.value as string);
  };

  const handleStaffAssignedChange = (event: SelectChangeEvent<unknown>) => {
    const value = event.target.value;
    const nextValue = typeof value === "string" ? value.split(",") : (value as any[]);
    setStaffAssignedVal(nextValue);
  };

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        // if (
        //   event.type === "keydown" &&
        //   ((event as React.KeyboardEvent).key === "Tab" ||
        //     (event as React.KeyboardEvent).key === "Shift")
        // ) {
        //   return;
        // }
        // console.log(`Toogle Drawer: DockAt:${anchor}, Show: ${open}`);
        // setState({ ...state, [anchor]: open });
        // if (!open) props.handleClose();
      };
  const toLocalTime = (date: Date): string => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"),
        "dd-MMM-yyyy hh:mm:ss",
        { zone: "UTC" }
      )
        .toLocal()
        .toFormat("dd-MMM-yyyy hh:mm:ss");

      return _date;
    } else return "";
  };
  useEffect(() => {
    setLoading(true);

    if (
      typeof props.dockAt !== "undefined" &&
      typeof props.show !== "undefined"
    ) {

      // toggleDrawer(props.dockAt, props.show);
      if (props.show) setState({ ...state, [props.dockAt]: props.show });
    }
    setApprovalComment((old) => "");

    // if (
    //   (getFilingMasterWorkflowComments &&
    //     props.statusRecords &&
    //     props.statusRecords.workflowId) ||
    //   (getFilingMasterWorkflowComments &&
    //     props.rowData &&
    //     props.rowData.workflowId)
    // ) {
    //   console.log(`Fetching Commnet for :${props.statusRecords?.workflowId}`);
    //   console.log(`Fetching Commnet for rowdata :${props.rowData?.workflowId}`);
    //   //   fetchFilingMasterComments(props.statusRecords.workflowId);
    // }
    //eslint-disable-next-line
  }, [props.show]);





  //   useEffect(() => {
  //     // if(props.statusRecords && props.statusRecords.createDate!==null)
  //     //eslint-disable-next-line
  //   }, [props.statusRecords]);

  //   const fetchFilingMasterComments = async (filingId: number) => {
  //     console.log("@@Fetch FilingMasters1:", getFilingMasterWorkflowComments);
  //     if (getFilingMasterWorkflowComments) {
  //       console.log("@@Fetch FilingMasters2:");
  //       try {
  //         const commentList = await getFilingMasterWorkflowComments(filingId);
  //         setData(() => commentList);
  //         console.log("@@Fetch FilingMasters2 comments:", commentList);
  //       } catch (error) {
  //         console.log("@@Error:", error);
  //       }
  //     }
  //   };

  //   useEffect(() => {
  //     console.log(`Fetching Commnet for 0:${props.statusRecords}`);
  //     if (
  //       typeof props.dockAt !== "undefined" &&
  //       typeof props.show !== "undefined"
  //     ) {
  //       console.log(
  //         `Toogle Drawer UED: DockAt:${props.dockAt}, Show: ${props.show}`
  //       );
  //       // toggleDrawer(props.dockAt, props.show);
  //       setState({ ...state, [props.dockAt]: props.show });
  //     }
  //     setApprovalComment((old) => "");

  //     if (
  //       getFilingMasterWorkflowComments &&
  //       props.statusRecords &&
  //       props.statusRecords?.workflowId
  //     ) {
  //       console.log(`Fetching Commnet for :${props.statusRecords.workflowId}`);
  //       fetchFilingMasterComments(props.statusRecords?.workflowId);
  //     }
  //     //eslint-disable-next-line
  //   }, []);
  // const getFilename = function (str: any) {
  //   return str ? str.replace(/^.*[\\\/]/, "") : "";
  // };

  const getFilenameToolip = function (str: any) {
    return str ? str.replace(/^.*[\\\/]/, "") : "";
  };
  const getFilename = function (str: any) {
    const MAX_FILENAME_LENGTH = 20;

    if (str) {
      let filename = str.replace(/^.*[\\\/]/, "");
      if (filename.length > MAX_FILENAME_LENGTH) {
        const halfLength = Math.floor((MAX_FILENAME_LENGTH - 3) / 2);
        const firstHalf = filename.substr(0, halfLength);
        const secondHalf = filename.substr(-halfLength);
        filename = `${firstHalf}...${secondHalf}`;
      }
      return filename;
    } else {
      return "";
    }
  };

  const getUserName = (userId: string) => {


    const user = userRoles
      ? userRoles?.filter((user) => user.loginId === userId)[0]?.userName
      : "";
    return user;
  };

  const list = (anchor: Anchor) => (
    <Fragment>
      <CustomDialog
        header="Info"
        visible={showAlert}
        onHide={() => closeAlert()}
        footer={null}
      >
        <p className="m-0">{alertMessage}</p>
      </CustomDialog>
      <Grid container>
        <Stack
          sx={{
            width: anchor === "top" || anchor === "bottom" ? "auto" : "20vw",
            minWidth: "35vw",
            display: "flex",
            alignContent: "center",
          }}
          role="presentation"
          onClick={toggleDrawer(anchor, false)}
          onKeyDown={toggleDrawer(anchor, false)}
        >
          {isLoading ? (
            <Loader />
          ) : (
            <Card sx={{ border: "none", boxShadow: "none" }}>
              <CardContent sx={{ mx: "10px", my: "10px" }}>
                <Stack direction="column" spacing={2}>
                  <Stack direction="row" alignItems="center" justifyContent="space-between" className="tn-bulk-header" sx={{ width: "100%" }}>
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="div"
                      sx={{
                        fontWeight: "500px",
                        fontSize: "22px",
                        color: "#424242",
                      }}
                    >
                      Bulk Update
                    </Typography>
                    <IconButton>
                      <CloseIcon onClick={() => handleCancel(anchor)} />
                    </IconButton>
                  </Stack>
                  <List>
                    {selectedRecords &&
                      selectedRecords.map((item: any, index: number) => (
                        <Fragment key={index}>
                          <Box sx={detailRowSx}>
                            <Typography sx={detailLabelSx}>Filing Name :</Typography>
                            {item.filingName.length > 10 ? (
                              <Tooltip title={item.filingName} arrow>
                                <Typography component="span" sx={detailValueSx}>
                                  {item.filingName}
                                </Typography>
                              </Tooltip>
                            ) : (
                              <Typography sx={detailValueSx}>{item.filingName}</Typography>
                            )}
                          </Box>

                          <Box sx={detailRowSx}>
                            <Typography sx={detailLabelSx}>Filing Due Date :</Typography>
                            <Typography sx={detailValueSx}>{item.dueDateFilingFormatted}</Typography>
                          </Box>

                          <Box sx={detailRowSx}>
                            <Typography sx={detailLabelSx}>Status :</Typography>
                            <Typography sx={detailValueSx}>{item.status}</Typography>
                          </Box>

                          <Box sx={detailRowSx}>
                            <Typography sx={detailLabelSx}>Staff Assigned :</Typography>
                            <Typography sx={detailValueSx}>
                              {[
                                ...commonStaffs.map((ele: any) => ele.userName),
                                ...(item.remainingStaffs || []).map((ele: any) => ele.userName),
                              ]
                                .filter(Boolean)
                                .join(", ")}
                            </Typography>
                          </Box>

                          <Divider sx={{ my: 1.5 }} />
                        </Fragment>
                      ))}
                  </List>
                  <div>
                    <CardActions>
                      <Stack direction="column" spacing={3}>
                        <Stack direction="row">
                          <Grid container>
                            {/* Row 1: Typography and FormControl */}
                            <Grid item style={{ height: "100px" }}>
                              <Typography sx={{ fontSize: "0.9rem" }} >Please select the status for Bulk Approval:</Typography>
                            </Grid>

                            <Grid item style={{ height: "100px" }}>
                              <Typography sx={{ fontSize: "0.9rem" }} >Please select the staff assigned for Bulk Approval:</Typography>
                            </Grid>

                            {/* <Grid item style={{ height: "100px", paddingTop: "40px" }}>
                          <MuiButton variant="contained" color="secondary" onClick={() => handleCancel(anchor)} sx={{ width: "120px", marginTop: "8px" }}>
                            Cancel
                          </MuiButton>
                        </Grid> */}
                          </Grid>
                          <Grid container>
                            <Grid item>
                              <FormControl sx={{ minWidth: 200, maxWidth: 200 }}>
                                <TrackNowSelect
                                  id="demo-select-small"
                                  value={statusOptValue}
                                  onChange={handleStatausChange}
                                  disabled={!hasChangeStatusPermission}
                                  displayEmpty
                                  input={<OutlinedInput />}
                                  renderValue={(selected) => {
                                    const value = selected as string;
                                    if (!value) {
                                      return <span style={{ color: "#9E9E9E" }}>Select status</span>;
                                    }
                                    const match = statusDropdown.find((item) => item.code === value);
                                    return match ? match.name : value;
                                  }}
                                >
                                  {statusDropdown.map((item, index) => (
                                    <MenuItem disabled={!hasChangeStatusPermission} key={index} value={item.code}>
                                      {item.name}
                                    </MenuItem>
                                  ))}
                                </TrackNowSelect>
                              </FormControl>
                            </Grid>
                            <Grid item>
                              <FormControl sx={{ minWidth: 200, maxWidth: 200 }}>
                                <TrackNowSelect
                                  id="demo-multiple-checkbox"
                                  multiple
                                  value={staffAssignedVal}
                                  onChange={handleStaffAssignedChange}
                                  input={<OutlinedInput />}
                                  renderValue={(selected) => {
                                    const values = Array.isArray(selected) ? selected : [];
                                    if (values.length === 0) {
                                      return <span style={{ color: "#9E9E9E" }}>Select staff assigned</span>;
                                    }
                                    const names = displayStaffVal(values).split(", ").filter(Boolean);
                                    const visible = names.slice(0, 1);
                                    const remaining = names.length - visible.length;
                                    return (
                                      <span style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                        {visible.join(", ")}
                                        {remaining > 0 ? `... + ${remaining} more` : ""}
                                      </span>
                                    );
                                  }}
                                  disabled={!hasStaffAssignedPermission}
                                  displayEmpty
                                >
                                  {staffAssignedList.map(({ name, code }) => (
                                    <MenuItem disabled={!hasStaffAssignedPermission} key={name} value={code}>
                                      <Checkbox checked={staffAssignedVal.indexOf(code) > -1} />
                                      <ListItemText primary={name} />
                                    </MenuItem>
                                  ))}
                                </TrackNowSelect>
                              </FormControl>
                            </Grid>
                            {/* <Grid item >
                          <MuiButton
                            variant="contained"
                            type="submit"
                            sx={{ backgroundColor: "#0b3edf", width: "120px" }}
                            onClick={() => handleOk(anchor)}
                          // disabled={!(statusOptValue || staffAssignedVal.length > 0)}
                          >
                            Update
                          </MuiButton>
                        </Grid> */}
                          </Grid>
                        </Stack>
                        {showError && <Alert severity="error">{alertMessage}</Alert>}
                        <Stack direction="row" justifyContent="flex-end" spacing={2}>
                          <TrackNowButton variant="tertiary" onClick={() => handleCancel(anchor)}>
                            Cancel
                          </TrackNowButton>
                          <TrackNowButton variant="tertiary" onClick={() => handleDeferConfirmation(anchor)}>
                            Defer
                          </TrackNowButton>
                          <TrackNowButton
                            variant="primary"
                            onClick={() => handleOk(anchor)}
                          // disabled={!(statusOptValue || staffAssignedVal.length > 0)}
                          >
                            Update
                          </TrackNowButton>
                        </Stack>
                      </Stack>

                    </CardActions>
                  </div>
                </Stack>
              </CardContent>
            </Card>
          )}

        </Stack>
      </Grid>
    </Fragment >
  );

  const onCommentChange = async (e: React.ChangeEvent<any>) => {
    setApprovalComment((old) => e.target.value);
    if (approvalComment) {
      setShowSuccess(false);
      setShowError(false);
    }
  };

  const handleOk = async (anchor: Anchor) => {
    console.log("handleOk", childList, "selectedRecords", selectedRecords, "props.statusRecords", props.statusRecords)
    console.log("handleOk", "statusOptValue", statusOptValue)

    try {
      if (props.statusRecords) {


        const filteredCommonStaffs = commonStaffs.filter((commonStaff: { userId: any }) => !staffAssignedVal.includes(commonStaff.userId));
        if (statusOptValue !== "" || staffAssignedVal.length > 0 || filteredCommonStaffs.length > 0) {

          setIsLoading(true);
          let recordList = childList
          //console.log("handleOk", "recordList", recordList, "staffAssignedVal", staffAssignedVal, "commonStaffs", commonStaffs);
          // console.log("handleOk filteredCommonStaffs", filteredCommonStaffs, "recordList", recordList);
          const payLoad =
            recordList
              .filter((item) => {
                // console.log("handleOk item", item)
                let staffId = item?.staffAssigned ? item.staffAssigned.map((ele) => ele.userId) : []
                let newStaffId = staffAssignedVal.filter(val => !staffId.includes(val))
                // console.log("handleOk newStaffId", staffId, staffAssignedVal, newStaffId)
                // console.log("handleOk statusOptValue", statusOptValue, item.status)
                if ((statusOptValue !== "" && statusOptValue.toLowerCase() !== item.status?.toLowerCase())
                  || newStaffId.length > 0 || filteredCommonStaffs.length > 0) {
                  return item
                }
              })
              .map((item) => {
                const fileTrackingId = item.fileTrackingId;
                const status = statusOptValue !== "" ? statusOptValue : item.status;
                const updateDate = new Date();
                const updateUser = authUser?.userId + '';
                let customerId = clientId;
                let staffId = item?.staffAssigned ? item.staffAssigned.map((ele) => ele.userId) : []
                //   const staffAssignedId = item?.staffAssigned ? item.staffAssigned.map((ele) => ele.staffAssignedId) : []
                let newStaffId = staffAssignedVal.filter(val => !staffId.includes(val))
                // console.log("handleOk newStaffId", newStaffId, "filteredCommonStaffs", filteredCommonStaffs);
                const staffAssigned = newStaffId.map((ele) => ({
                  staffAssignedId: 0,
                  fileTrackingID: item.fileTrackingId,
                  userId: ele,
                  createDate: new Date(),
                  createUser: authUser?.userId + '',
                  isDeleted: false
                }))

                const removedStaffAssigned = filteredCommonStaffs.map((ele: { userId: any }) => {
                  const matchingStaff = item.staffAssigned
                    ? item.staffAssigned.find((id) => ele.userId === id.userId)
                    : null;

                  // Extract the staffAssignedId or set to null if no match found
                  const staffAssignedId = matchingStaff ? matchingStaff.staffAssignedId : null;
                  //console.log("handleOk matchingStaff ", matchingStaff, "staffAssignedId", staffAssignedId);

                  return {
                    staffAssignedId: staffAssignedId,
                    fileTrackingID: item.fileTrackingId,
                    userId: ele.userId,
                    createDate: new Date(),
                    createUser: authUser?.userId + '',
                    isDeleted: true
                  }
                })
                //console.log("handleOk return", fileTrackingId, status, updateDate, updateUser, staffAssigned, removedStaffAssigned)

                return { fileTrackingId, status, updateDate, updateUser, staffAssigned: [...staffAssigned, ...removedStaffAssigned], customerId }
              })
          const combainedPayload = [...payLoad]
          //  console.log("handleOk combainedPayload", combainedPayload)

          const res: any = await axios.put(
            `${API_BASE_URL}/Customer/UpdateMultipleCustomerFileTracking`,
            combainedPayload
          );
          if (statusOptValue === "Completed") {
            const filtPropPayload = selectedRecords.filter((filt) => filt.status !== "Completed").map((item) => ({
              customerId: item.customerId,
              filingId: item.filingId,
              fileTrackingId: item.fileTrackingId,
              recordType: item.recordType,
            }))
            console.log("handleOk", "filtPropPayload", filtPropPayload)
            const res = await axios.post(
              `${API_BASE_URL}/Customer/CustomerFileTrackingCompletedEmail`,
              filtPropPayload
            );

          }
          setFilingName(selectedRecords.map((item) => item.filingName));
          if (res.status) {
            setAlertMessage('Successfully updated the records for');
            setState({ ...state, [anchor]: false });
            setSelectedRecords([])
            setStatusOptValue("")
            setStaffAssignedVal([])
            if (props.setClearSelectedRecords) {
              props.setClearSelectedRecords(true)
            }
            if (props?.handleClose) {
              props.handleClose();
            } if (props.handleRefreshTable) {
              props.handleRefreshTable()
            }

          } else {
            setAlertMessage(res.errorMessage);
          }
          setShowAlert(true);
          setIsLoading(false);
        } else {
          setShowError(true)
          setAlertMessage("Please change any of the field")
        }
      }
    } catch (error) {
      console.error("handleOk error", error)
      setState({ ...state, [anchor]: false });
      if (props?.handleClose) {
        props.handleClose();
      }
      setAlertMessage('Unexpected Error Occured during bulk status update');
      setShowAlert(true);

    }

  };
  const hasChangeStatusPermission = usePermission(
    "ClientFilingList",
    "changeStatus",
  );
  const hasStaffAssignedPermission = usePermission(
    "ClientFilingList",
    "changeStaff",
  );

  const handleCancel = async (anchor: Anchor) => {
    setShowSuccess(false);
    setShowError(false);
    setSelectedRecords(() => []);
    setStatusOptValue("")
    setState({ ...state, [anchor]: false });
    props.handleClose();
  };

  const { AlertDialog, showDialog, closeDialog } = useDialog({
    onSubmit: () => {

      handleDefer("right")
    },
    onClose: () => {
      handleCloseDefer()
    }
  });
  const handleCloseDefer = async () => {
    closeDialog()
    setState({ ...state, "right": true });
  };

  const handleDeferConfirmation = (anchor: Anchor) => {
    console.log("handleDeferConfirmation anchor", anchor);

    setState({ ...state, "right": false });
    showDialog(
      "Confirmation",
      " Are you sure you want to move these filings to deferred list ?",
      "confirm"
    );
  }

  const handleDefer = async (anchor: Anchor) => {
    setIsLoading(true)
    try {

      let uniqueRecords = selectedRecords;

      if (!props.isDetailedView) {
        const payload = selectedRecords.map(item => ({
          customerId: props.selectedClientId,
          filingId: item.filingId,
          PreviousStartDate: item.previousStartDate,
          customerType: props.selectedCustomer?.clientType
        }));
        const resAffectedCompanies = await axios.post(
          `${API_BASE_URL}/Customer/CustomerandFilingListBasedOnParentdetails`,
          payload
        );

        const affectedCompanyDetails = resAffectedCompanies.data.data;

        // Combine both arrays
        const combinedRecords = [...selectedRecords, ...affectedCompanyDetails];

        // Remove duplicates
        uniqueRecords = Array.from(
          new Map(combinedRecords.map(item => [item.fileTrackingId, item])).values()
        );

      }
      // 3. Map over the unique array to create the final payload 
      // This automatically extracts (filters) only the required fields
      const deferPayload = uniqueRecords.map(item => ({
        fileTrackingId: item.fileTrackingId,
        UserId: authUser?.userId + "",
        customerId: item.customerId,
        filingId: item.filingId,
        year: new Date(item.startdate).getFullYear() + "",
      }));
      console.log("handleDefer", "deferPayload", deferPayload)

      let res = await axios.post(
        `${API_BASE_URL}/Customer/ClientSpecificFilingDelete`,
        deferPayload
      );
      if (res.data.status === "Success") {
        setAlertMessage('Successfully defered the filings');
        setShowAlert(true);
        setIsLoading(false);
        setState({ ...state, [anchor]: false });
        setSelectedRecords([])
        setStatusOptValue("")
        setStaffAssignedVal([])
        if (props?.handleClose) {
          props.handleClose();
        } if (props.handleRefreshTable) {
          props.handleRefreshTable()
        }

      } else {
        setAlertMessage(res.data.errorMessage);
      }

    } catch (error) {
      console.log("error", error);

    }

  };



  return (
    <div>
      {/* {(["left", "right", "top", "bottom"] as const).map((anchor) => (
        // <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
      <CustomDialog
        header="Info"
        visible={showAlert}
        onHide={() => closeAlert()}
        footer={null}
      >
        <p className="m-0">{alertMessage}</p>
        {filingName.length > 0 && (
          <ul>
            {Array.from(new Set(filingName)).map((name, index) => (
              <li key={index}><strong>{name}</strong></li>
            ))}
          </ul>
        )}
      </CustomDialog>
      {typeof props.dockAt !== "undefined" && (
        <React.Fragment>
          <Drawer
            anchor={props.dockAt}
            open={state[props.dockAt]}
            onClose={toggleDrawer(props.dockAt, false)}
          >
            {list(props.dockAt)}
          </Drawer>
          <AlertDialog />
        </React.Fragment>
      )}
    </div>
  );
}
